import * as React from "react"

import Svg, { G, Mask, Path } from "react-native-svg"

import { IconProps } from ".."

const Security = ({ size = 24, color = "#000", ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}>
    <Mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}>
      <Path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#6826A0"
        d="M12 22c-2.317-.583-4.23-1.913-5.737-3.988C4.754 15.938 4 13.633 4 11.1V5l8-3 8 3v6.1c0 2.533-.754 4.838-2.262 6.912C16.229 20.087 14.317 21.418 12 22Zm0-2.1c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3ZM10 16h4c.283 0 .52-.096.713-.287A.968.968 0 0 0 15 15v-3a.968.968 0 0 0-.287-.713A.968.968 0 0 0 14 11v-1c0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 8c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 10v1a.967.967 0 0 0-.713.287A.968.968 0 0 0 9 12v3c0 .283.096.52.287.713.192.191.43.287.713.287Zm1-5v-1c0-.283.096-.52.287-.713A.968.968 0 0 1 12 9c.283 0 .52.096.713.287.191.192.287.43.287.713v1h-2Z"
      />
    </G>
  </Svg>
)
export default Security
